import { AuthWrapper } from '@app/core/auth/authentication';
import { AppRootRoutes } from '@app/core/auth/flow/AppRootRoutes';
import { ErrorBoundary } from '@app/core/error/ErrorBoundary';
import { RouterWrapper } from '@app/core/routing/RouterWrapper';
import { SplashOverlay } from '@app/core/splash/SplashOverlay';
import { NotificationsContainer } from '@mi-front/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { HelmetProvider } from 'react-helmet-async';
import { GrowthBookProviderWrapper } from '../integrations/growthbook/GrowthBookProviderWrapper';
import { queryClient } from '../integrations/react-query/react-query';
import { AppThemeProvider } from '../ui/AppThemeProvider';
import { FontSwitcher } from '../ui/FontSwitcher';
import { FatalErrorPreviewGate } from './FatalErrorPreviewGate';
import { HtmlTags } from './HtmlTags';
import { LanguageProvider } from './LanguageProvider';
import { SplashPreviewGate } from './SplashPreviewGate';
import { ZustandPersistGate } from './ZustandPersistGate';

// to preserve import when tools are commented out
const _ReactQueryDevtools = ReactQueryDevtools;

export function Root() {
  return (
    <GrowthBookProviderWrapper>
      <HelmetProvider>
        <LanguageProvider>
          <AppThemeProvider>
            <SplashOverlay />
            <SplashPreviewGate>
              <FatalErrorPreviewGate>
                {/* <CssBaseline /> */}
                <ErrorBoundary errScreen>
                  <HtmlTags />
                  {/* <BreakpointChip /> */}
                  <FontSwitcher />
                  <ZustandPersistGate>
                    <QueryClientProvider client={queryClient}>
                      <RouterWrapper>
                        <NotificationsContainer />
                        <AuthWrapper>
                          <AppRootRoutes />
                        </AuthWrapper>
                      </RouterWrapper>
                      {/* <_ReactQueryDevtools initialIsOpen={false} buttonPosition={'top-left'} /> */}
                    </QueryClientProvider>
                  </ZustandPersistGate>
                </ErrorBoundary>
              </FatalErrorPreviewGate>
            </SplashPreviewGate>
          </AppThemeProvider>
        </LanguageProvider>
      </HelmetProvider>
    </GrowthBookProviderWrapper>
  );
}
